export default __webpack_public_path__ + "static/media/blog-banner.64fa0128.png";